<template>
  <div>
    <div v-if="row.local_event">
      <addPay
        :level="level"
        :id="row.id.toString()"
        :row="row"
        :params="{
          dateStart: params.date_start,
          dateEnd: params.date_end,
        }"
        :api="getAddPayApi"
        platform="google"
        :accountId="row.ad_accountId.toString()"
      >
        <p
          class="color9"
          style="height: 20px; line-height: 20px"
          v-for="(item, index) in row.local_event"
          :key="index"
        >
          {{ item.eventTypeDesc }}(成本)：{{ item.eventCount }}({{ row.currency }}{{ item.costPrice }})
        </p>
      </addPay>
    </div>
    <div v-else>--</div>
  </div>
</template>

<script>
import { addPay } from '@adCommonComponent'

export default {
  name: 'LocalEventCell',
  components: {
    addPay
  },
  props: {
    row: {
      type: Object,
      required: true
    },
    level: {
      type: String,
      required: true
    },
    params: {
      type: Object,
      required: true
    },
    getAddPayApi: {
      type: Function,
      required: true
    }
  }
}
</script>